var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page white-bg with-title-bar with-footer-bar"},[_c('div',{staticClass:"content"},[_c('text-content',{attrs:{"content":_vm.content}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }